import { ReactComponent as CloseButton } from 'assett/icons/close_dialog_icon.svg';
import { ReactComponent as History } from 'assett/icons/history_icon.svg';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';

import { getHistory, resetHistory } from 'feature/history/historySlice';
import {
	BoxOverflow,
	Button,
	Drawer,
	IconButton,
	Stack,
	Typography,
} from 'styles';
import { HISTORY_TYPES } from 'types/History';
import { useTranslation } from 'utils/translations';
import HistoryItem from './HistoryItem.component';

const ClaimHistoryDrawer = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { claimData } = useSelector((store: RootState) => store.claim);
	const { claimHistory } = useSelector((store: RootState) => store.history);
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {
		if (!claimData.claimUUID) {
			return;
		}

		dispatch(
			getHistory({
				historyType: HISTORY_TYPES.CLAIM,
				uuid: claimData.claimUUID,
			}),
		);
	}, [dispatch, claimData.claimUUID]);

	useEffect(() => {
		return () => {
			dispatch(resetHistory());
		};
	}, [dispatch]);

	return (
		<>
			<Button
				startIcon={<History />}
				variant="text"
				onClick={handleOpen}
				sx={{
					pr: 0,
					pb: '20px',
					textDecoration: 'underline',
					gap: '8px',
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
			>
				{tClientLabels('claim.history.viewClaimHistoryButton')}
			</Button>

			<Drawer
				open={open}
				onClose={handleClose}
				anchor="right"
				PaperProps={{
					sx: {
						width: {
							xs: '420px',
							sm: '420px',
							md: '420px',
							lg: '460px',
							xl: '460px',
						},
						overflowY: 'hidden',
					},
				}}
				transitionDuration={250}
			>
				<Stack>
					<Stack
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}
						sx={{
							padding: {
								sm: '15px 20px',
								lg: '32px',
							},
							backgroundColor: 'grey6.main',
						}}
					>
						<Typography variant="title5">
							{tClientLabels('claim.history.drawerTitle')}
						</Typography>
						<IconButton onClick={handleClose}>
							<CloseButton />
						</IconButton>
					</Stack>
					<BoxOverflow
						variant="y"
						sx={{
							maxHeight: 'calc(100vh - 110px)',
							marginY: '6px',
							marginRight: '6px',
							paddingY: '32px',
							paddingX: {
								sm: '20px',
								lg: '32px',
							},
						}}
					>
						<Stack>
							{claimHistory?.map((item, index) => (
								<HistoryItem
									key={`history-item-${index}-${item.id}`}
									item={item}
									isLast={index === claimHistory.length - 1}
								/>
							))}
						</Stack>
					</BoxOverflow>
				</Stack>
			</Drawer>
		</>
	);
};

export default ClaimHistoryDrawer;
